<div class="review-notification-main">
    <div class="row address-container heading-text">
        <div class="col-md-5 col-lg-5 col-sm-5">
            <label>{{"quoteReview.quoteEmail" | cxTranslate}}</label>
        </div>
    </div>
    <div class="row address-container heading-value">
      <div class="col-md-5 col-lg-5 col-sm-5">
        <label>{{notificationEmail}}</label>
      </div>
    </div>
    <div *ngIf="userType === 'anonymous'" class="row address-container heading-text">
      <div class="col-md-5 col-lg-5 col-sm-5">
          <label>{{"quoteReview.contactNumber" | cxTranslate}} </label>
      </div>
  </div>
  <div *ngIf="userType === 'anonymous'" class="row address-container heading-value">
    <div class="col-md-5 col-lg-5 col-sm-5">
      <label>{{contactNumber}}</label>
    </div>
  </div>
    <div class="row address-container uploadFile-text" *ngIf="attachments">
        <div class="col-md-5 col-lg-5 col-sm-5">
          <label> {{"quoteReview.uploadedFile" | cxTranslate}}Uploaded File (s) </label>
        </div>
      </div>


      <div class="row address-container files" *ngFor="let file of attachments">
        <div class="col-md-5 col-lg-5 col-sm-5">
          <label class='uploaded-files'><span>{{file?.realFileName}}</span> <span class="size-text">{{getFileSize(file?.attachmentSizes)}}</span></label>
        </div>
      </div>
</div>